<template>
    <div class="checkout-order">
        <div class="container py-5">
            <div class="row">
                <div class="col-6 col-md-3" v-for="(product, i) in setProducts" :key="i">
                    <div class="checkout-order-item-wrap">
                        <div class="checkout-order-item-inner">
                            <template v-if="product.is_additional_product">
                                <a href="#" @click.prevent="showProductInformation(product.pricelist_set_product_id)">
                                    <span class="checkout-order-item" :style="{backgroundImage: product.product_images.length > 0 ? `url(${_.first(product.product_images).medium})` : ''}"></span>
                                </a>
                            </template>
                            <template v-else-if="product.photo">
                                <a href="#" @click.prevent="isEditableState ? showPhotoEditor(product.photo, {width: product.width, height: product.height}) : ''" :class="{'-disabled': !isEditableState}">
                                    <processed-photo v-if="!_.find(hiddenPhotos, {productId: product.id})" :item="product.photo" :width="product.width" :height="product.height"/>
                                </a>
                            </template>
                            <div v-else class="checkout-order-item checkout-order-item--no-img"></div>
                            <div class="checkout-order-item-actions">
                                <template v-if="product.is_additional_product">
                                    <a href="#" @click.prevent="showProductInformation(product.pricelist_set_product_id)" class="checkout-order-item-action checkout-order-item-action--txt checkout-order-item-action--icon-left">
                                        <span class="material-icon icon-info"/>
                                        {{ $t('more_info') }}
                                    </a>
                                </template>
                                <template v-else>
                                    <template v-if="!product.image_tag || product.image_tag && !+product.image_tag.not_changeable">
                                        <a href="#" v-if="product.photo" :id="`remove-set-item-${i}`" class="checkout-order-item-action" @click.prevent="deletePhoto(product)">
                                            <span class="material-icon icon-delete"/>
                                        </a>
                                        <b-tooltip placement="top" :target="`remove-set-item-${i}`">
                                            {{ $t('helpers.delete') }}
                                        </b-tooltip>
                                        <a href="#" :id="`change-set-item-${i}`" :class="['checkout-order-item-action', {'checkout-order-item-action--txt checkout-order-item-action--icon-left': !product.photo}]" @click.prevent="replacePhoto(product)">
                                            <template v-if="product.photo">
                                                <span class="material-icon icon-repeat"/>
                                            </template>
                                            <template v-else>
                                                <span class="material-icon icon-add"/>
                                                {{ $t('add_photo') }}
                                            </template>
                                        </a>
                                        <b-tooltip v-if="product.photo" placement="top" :target="`change-set-item-${i}`">
                                            {{ $t('helpers.change') }}
                                        </b-tooltip>
                                        <template v-if="album && isEditableState">
                                            <a href="#" v-if="product.photo" :id="`edit-set-item-${i}`" class="checkout-order-item-action" @click.prevent="showPhotoEditor(product.photo, {width: product.width, height: product.height})">
                                                <span class="material-icon icon-create"/>
                                            </a>
                                            <b-tooltip placement="top" :target="`edit-set-item-${i}`">
                                                {{ $t('helpers.edit') }}
                                            </b-tooltip>
                                        </template>
                                    </template>
                                    <template v-else-if="isEditableState">
                                        <a href="#" v-if="product.photo" :id="`edit-set-item-${i}`" class="checkout-order-item-action checkout-order-item-action--txt checkout-order-item-action--icon-left" @click.prevent="showPhotoEditor(product.photo, {width: product.width, height: product.height})">
                                            <span class="material-icon icon-create"/>
                                            {{ $t('edit') }}
                                        </a>
                                    </template>
                                </template>
                            </div>
                        </div>
                        <div class="checkout-order-txt">
                            <div class="checkout-order-txt-subtitle">{{ product.name }}</div>
                            <div class="checkout-order-txt-title"></div>{{ product.quantity }}x {{ product.product_name }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import ProcessedPhoto from '../ProcessedPhoto';

  import setStep1 from 'src/mixins/setStep1Component';

  export default {
    mixins: [setStep1],
    components: {
      ProcessedPhoto,
    },
  };
</script>